import BaseModel from 'volta/models/base-model';
import { _normalize, collectionCommand } from 'volta/utils/api';

import { attr } from '@ember-data/model';

import type {
  IForecastTypeSelection,
  ISelectSkuForecastTypesCmd
} from 'volta/models/types/forecasts';
import { Type } from '@warp-drive/core-types/symbols';

export enum SkuForecastTypeCommands {
  SelectSkuForecastTypes = 'SelectSkuForecastTypes'
}

/**
 * Represents a SKU forecast type
 */
export default class SkuForecastType extends BaseModel implements IForecastTypeSelection {
  /**
   * Selects the forecast types for a given SKU
   */
  static selectSkuForecastTypes = collectionCommand<
    ISelectSkuForecastTypesCmd,
    SkuForecastType[],
    typeof SkuForecastType
  >(SkuForecastTypeCommands.SelectSkuForecastTypes);

  @attr('string') skuId!: string;
  @attr('string') forecastProjectId?: string;
  @attr('string') forecastProjectName?: string;
  @attr('string') forecastType!: string;
  @attr('boolean') usedInADU!: boolean;
  @attr('boolean') usedInNetFlow!: boolean;
  @attr('string') updatedBy?: string;
  @attr('date') copiedAt?: string;

  /**
   *  Converts the model to a forecast type selection
   * @returns {IForecastTypeSelection} - The forecast type selection
   */
  toForecastTypeSelection(): IForecastTypeSelection {
    return {
      id: this.id,
      forecastProjectId: this.forecastProjectId,
      forecastType: this.forecastType,
      usedInADU: this.usedInADU,
      usedInNetFlow: this.usedInNetFlow
    };
  }

  [Type] = 'sku-forecast-type' as const;
}
